import { useEffect, useMemo, useState } from 'react';
import { Card, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

const Tabs = ({
    t
}) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsLinks = useMemo(() => {
        return [
            {
                key: "dashboard",
                title: "Dashboard"
            },
            {
                key: "overview",
                title: "Overview"
            },
            // {
            //     key: "risks",
            //     title: "Risks"
            // },
            {
                key: "queries",
                title: "Queries"
            },
            {
                key: "history",
                title: "History Log"
            }
        ];
    }, []);

    useEffect(() => {
        if(!tabsLinks.length) return;
        
        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = tabsLinks.find((tab) => tab.key === tabKey);

        if (!tab) {
            history.push({
                search: '?tab=' + tabsLinks[0].key
            });
        }
        else {
            setActiveTab(tab.key);
        }
    }, [
        location.search,
        tabsLinks,
        history
    ]);

    return (
        <Row>
            <Col sm="12">
                <div style={{
                    backgroundColor: '#D1D2D6',
                }}>
                    <Nav tabs className="custom-style-1">
                        {
                            tabsLinks.map((link) => {
                                return (
                                    <NavItem className={isActiveTab(activeTab, link.key) ? 'active': ''} key={link.key}>
                                        <NavLink className={isActiveTab(activeTab, link.key) ? 'active': ''}
                                            onClick={() => history.push({
                                                search : '?tab=' + link.key
                                            })}>
                                            {t(link.title)}
                                        </NavLink>
                                    </NavItem>
                                )
                            })
                        }
                    </Nav>
                </div>
            </Col>
        </Row>
    );
};

export default withNamespaces()(
    withRouter(Tabs)
);
